export default {
    login: {
        welcomeMsg: "Welcome! Login",
        info: "Enter your credentials.",
        forgot: "Forgot Password?",
        btn: "Login",
        unableToLogin: "Unable to Login",
      },
      forgot: {
        info_l1:
          "Please enter the email address associated with your account. Password details will be sent to your email/mobile address.",
        info_l2:
          "Please enter your mobile number associated with your account. Password details will be sent to phone number.",
        info_l3:
          "Please choose one of the following options to receive instructions on how to reset your password",
        forgotQ: "Forgot Your Password?",
        loginNow: "Login Now",
        resetSucc: "Your password is reset successfully",
        resetSucc_l2:
          "You can now use your new password to login into your account.",
        entPsw: "Please enter your new password.",
        resetPsw: "Reset Your Password",
        resendOTP: "Resend OTP",
        enterCorrectOTP: "Please enter correct OTP.",
        enterOTP: "Please enter OTP received on email/mobile.",
        backToLoginPage: "Back to Login page",
        recieveCodeFalse: " I didn't receive the code",



        changePassword: "Change Password",
        changePasswordSubtitle: "Please enter your new password below",
        oldPassword: "Old Password",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        resetPassword: "Reset Password",
        resetPasswordSubtitle: "Please enter your new password below",
        resetPasswordBtn: "Reset Password",
        backToLogin: "Back to Login",
        oldPasswordRequired: "Old password is required",

        passwordResetSuccess: "Password reset successfully",
        passwordResetFailed: "Failed to reset password",
        errorOccurred: "An error occurred",
      },

     
      permissions: {
        savePermissions: "SAVE PERMISSIONS",
        moduleName: "Module Name",
        view: "View",
        create: "Create",
        update: "Update",
        delete: "Delete",
        permissionsUpdated: "Permissions Updated",
        permissionsNotUpdated: "Permissions not Updated",
        selectMembership: "Select Membership",
        noPermMsg:
          "Please select the membership type using the 'Membership Type' drop down above to view your permissions",
        selectRoleMsg: "Please select the Role above to show permissions",
      },

      activationKey: {
        logs: {
          time: "Time",
          username: "User Name",
          role: "Role",
          terminalID: "Terminal ID",
          moduleAccessed: "Module Accessed",
          typeOfAccess: "Type of Access",
          activityLogDetails: "Activity Log Details",
          userId: "User ID",
          lastLogin: "Last Login",
          geoAccPoint: "Geographical access point",
          ipAdd: "IP address",
          filesAccessed: "Files accessed",
          funAccessed: "Function accessed",
          webUrl: "Web page URL",
          unsuccAtmp: "Unsuccessful Login attempt",
          view: "View",
          membershipType: "Membership Type",
        },
        memberDataSection: {
          import: "Import",
          buyingStation: "Buying Station",
          continue: "Continue",
          farmerId: "Farmer ID",
          farmerName: "Farmer Name",
          farmerAddress: "Farmer Address",
          quality: "Quality",
          quantity: "Quantity",
          importAll: "Import All",
          importSelected: "Import Selected",
          fileLoaded: "File loaded successfully",
          incorrectHeaders: "Incorrect headers",
          processingBatch: "Processing Batch",
          purchaseOrder: "Purchase Order",
          startDate: "Start Date",
          endDate: "End Date",
          purchasingOrder: "Purchasing Order",
          totalCoffeeCherry: "Total Coffee Cherry",
          airHumidity: "Air Humidity",
          density: "Density",
          temperature: "Temperature",
          beanMoistureContent: "Bean Moisture Content",
          processType: "Process Type",
          batchRating: "Select Rating Of The Batch",
          purchaseDate: "Purchase Date",
          selectFarmer: "Select Farmer",
          selectFarmers: "Select Farmers",
          selectFarm: "Select Farm",
          selectPlantation: "Select Plantation",
          coffeeVariety: "Coffee Variety",
          coffeeSpecies: "Coffee Species",
          coffeeCherryQuantity: "Coffee Cherry Quantity",
          coffeeCherryQuality: "Coffee Cherry Quality",
          coffeeType: "Type of Coffee",
          pricePerKg: "Price Per Kg",
          processingDone: "Processing Done",
          processedCoffeeOut: "Processed Coffee Out",
          farmer: "Farmer",
          farm: "Farm",
          plantation: "Plantation",
    
          // Lately added
          farmers: "Farmers",
          farmLimitUsed: "Farm Limit Used",
          phoneNumber: "Phone Number",
          farmSize: "Farm Size",
          farmLocation: "Farm/Location",
          date: "Date",
          status: "Status",
          noFarmers: "No Farmers Found",
          approveReject: "Approve/Reject",
          farms: "Farms",
          crops: "Crops",
          equipment: "Equipment",
          noFarms: "No Farms Found",
          views: "View",
          selectStatus: "Select Status",
          approved: "Approved",
          rejected: "Rejected",
          reject: "Reject",
          approve: "Approve",
          cancel: "Cancel",
          add: "Add",
          describeYourReason: "Describe your reason here",
          userInformation: "User Information",
          userFarmRequest: "User Farm Request",
          userFarmInformation: "User Farm(s) Information",
          activity: "Activity",
          activityType: "Activity Type",
          farmZone: "Farm Zone",
          farmerView: "Farmer View",
          cropType: "Crop Type",
          cropVarity: "Crop Varity",
          area: "Area",
          cost: "Cost",
          geofence: "Geofence",
          map_views: "Map View",
          viewAllFarms: "View All Farms",
          farmersDetails: "Farmer Details",
          download: "Download",
          pOrder: {
            addNew: "Add New",
            viewAll: "View All",
            selectDate: "Select date",
            makeSelection: "Make a selection",
            coffeeType: "Type coffee quantity",
            enterPrice: "Enter Price",
            reqPurchaseDate: "Purchase date is required",
            reqFarmer: "Farmer is required",
            reqCoffeeQnty: "Coffee Cherry Quantity is required",
            reqPrice: "Price Per Kg is required",
            grandTotal: "GRAND TOTAL",
            selectDateRange: "Select Date Range",
            import: "Import",
            purchaseId: "Purchase Id",
            purchaseDate: "Purchase Date",
            farmerName: "Farmer Name",
            quality: "Quality",
            quantity: "Quantity",
            pricePerKg: "Price Per Kg",
            selectBuyingStation: "Select buying station",
            searchUser: "Search Users",
            purchaseListView: "Purchase List View",
            viewBy: "View by",
            typeDensity: "Type Density",
            typeTemperature: "Type temperature",
            typeWaterContent: "Type water content",
          },
          farmActivity: "Farm Activity",
          showOnMap: "Show On Map",
          farmInformation: "Farm Information",
          dateOfEntry: "Date Of Entry",
          farmID: "Farm ID",
          ownershipType: "Ownership Type",
          locationAddress: "Location Addresss",
          goalType: "Goal Type",
          totalSize: "Total Size",
          zones: "Zones",
          farmActivities: "Farm Activites",
          farmDetails: "Farm Details",
          totalFarmsRegistered: "Total Farms Registered",
          totalFarmArea: "Total Farm Area",
          totalZone: "Total Zone",
          zone: "Zone",
    
          totalCost: "Total Cost",
          selectFarmZone: "Select Zone/Farm",
          productionType: "Production Type",
          certifications: "Certifications",
          geofences: "Geofences",
          farmsChart: "Farms Chart",
        },
        enterActivationKey: "Please enter activation key to register a new user",
        mitigation: "Manual Risk Mitigation",
        countryRequired: "Country is Required",
        activationKeyRequired: "Activation Key is Required",
        activationKey: "Activation Key",
        activationKeyLimit: "Activation Key Too Short",
        membershipRoleFilterDesc: "Filter Membership Plan by Role",
        email: "Email",
        filterBy: "Filter By",
        membershipRoleFilter: "Membership Role Filter",
        // enterActivationKey: "Please enter activation key to register a new user",
        // activationKeyLimit: "Minimum 15 characters",
        // countryRequired: "Country Code is required",
    
        appointSalesManager: "Appoint Sales Manager",
        appointManager: "APPOINT MANAGER",
        salesManAppSuccess: "SALES MANAGER APPOINTED SUCCESSFULLY",
        uploadData: "UPLOAD ASSIGNED DATA CSV",
        uploadUserData: "Please upload the user data file",
        downloadCsv: "Download the sample .csv file to follow the structure",
        downloadSample: "Download sample file",
        dragDrop: "Drag and drop or",
        browse: "browse",
        yourFile: "your file",
        pdfSupport: "Only PDF files are supported.",
        pleaseWait: "Please Wait",
        note: "Note",
        incorectFileType: "Incorrect file type",
        somethingWentWrong: "Something went wrong",
        fileUploadedSuccess: "File Uploaded Successfully",
        countRecords: "Count Records",
        sendNow: "SEND NOW",
        fileName: "file-name",
        assignActKey: "Assigning Activation Keys",
        actKeyAssSucc: "Activation keys assigned successfully",
        viewActKey: "VIEW ACTIVATION KEYS",
        actKeyQuota: "Activation Keys Quota",
        genActKey: "Generated Activation Keys",
        remActKey: "Remaining Activation Keys",
        penUsed: "Pending and Used Keys",
        activationKeyAss: "Activation Keys Assigned",
        activationKeyUnass: "Activation Keys Unassigned",
        keysAct: "Keys Activated",
        uploadedFiles: "Uploaded Files",
        generateActKey: "GENERATE ACTIVATION KEYS",
        showData: "Show Data",
        noDataFound: "No Date Found",
        pleaseGenKey:
          'Please generate the activation keyss using the "Generate Activation Keyss"',
        noActKey: "No activation keyss generated yet",
        buttonAbv: "button above",
        numberOfActKey: "Number of Activation Keys",
        membershipRole: "Membership Role",
        membershipPlan: "Membership Plan",
        comments: "Comments",
        genKeys: "GENERATE KEYS",
        keysNum: "Keys Number",
        phoneNumber: "Phone Number",
        keysStatus: "Keys Status",
        ActivationKeysList: "Activation Keys List",
        back: "BACK",
        usingActKeys: 'using the "Generate Activation Keyss"',
        pleaseGenActKeyss: "Please generate the activation keyss",
        clearAllFilters: "CLEAR ALL FILTERS",
        salesManager: "Sales Manager",
        clearAll: "CLEAR ALL",
        generatedBy: "Generated By",
        numberOfKeys: "Number of Keys",
        action: "Action",
        viewAllUplFiles: "VIEW ALL UPLOADED FILES",
        bulkUploadUsers: "BULK UPLOAD USERS",
        noActivationKeyFound: "No Activation Keys Found",
        pleaseCreateAdminRole: "Please create admin role using the",
        btnCreateAdmin: "button 'Create Admin Role' above",
        donwloadAsCsv: "Download as CSV",
        donwloadAsPdf: "Download as PDF",
        assignSalesManager: "Assign Sales Manager",
        shareViaEmail: "Share via Email",
        memberRequired: "membership is required",
        memberRoleRequired: "Membership role is required",
        memberKeyRequired: "Key value is required",
        enterComment: "Enter your comment here",
        sendEmail: "SEND EMAIL",
        emailSend: "EMAIL SENT SUCCESSFULLY",
        donwload: "Download",
        deleteFile: "Delete File",
        invalidFileData:
          "Activation key, email, and mobile number data in file are invalid",
      },

      profileSetting: {
        defaultOrganizationOTPForSignUp: "Default Organization OTP For Signup",
        whoreceivedthealert: "Who Receives the Alert",
        otp: "OTP",
        passwordReuse: "Password Reuse",
        organizationSplashScreen: "Organizational Splash Screen",
        organizationSplash1: "Organization Splash",
        generateOtp: "Generate OTP",
        addAnother: "Add Another",
        dragAndDropOr: "Drag & Drop or Browse",
        browse: "Browse",
        save: "Save",
    
        profileAuthSettings: "Profile Authentication Settings",
        changeSettings: "CHANGE SETTINGS",
        loginLogoutSettings: "Login/Logoff Settings",
        autoLogout: "Auto-log off",
        unsuccAtmp: "Unsuccessful Login Attempts",
        unsuccLoginLock: "Unsuccessful login Lock-out period",
        pswCrisetup: "Password Criteria Setup",
        pswLength: "Password length",
        noOfUniquePsw: "Number of unique passwords required ",
        maxPswAge: "Maximum password age",
        AccRangeOfchars: "Acceptable range of characters",
        upperCase: "Upper Case",
        lowerCase: "Lower Case",
        numbers: "Numbers",
        specialChars: "Special characters",
        settingsUpdated: "Settings Updated",
        settingsNotUpdated: "Settings Not Updated",
        organization: "Organization",
        organizationLogo: "Organization Logo",
        organizationSplash: "Organization Splash Screen",
        cropsHarvestAlert: "Crop Harvest Alerts",
        alertCrop: "Crop",
        alertCropInfo: "Crop for which you will get alert",
        alertCountry: "Country",
        alertCountryInfo: "Country for which you'll get alerted",
        alertRegion: "Region",
        alertRegionInfo:
          "Region of the selected country for which you'll get alerted",
        alertMaximum: "Maximum quantity",
        alertMaximumInfo: "Maximum quantity allowed after which you'll get alerted",
        selectCrop: "Select Crop",
        alertFor: "Select who receives the alert",
        alertAdmin: "Alert admin",
        alertFarmer: "Alert Farmer",
        selectCountry: "Select Country",
        selectCountryInfo: "Choose the geographic location applicable to the assessment.",
        maxProduction: "Maximum Production / Hectares / Year",
        maxAllowed: "Max Allowed / Ha / Yr",
        alert: "Alert",
        defaultOtpOrganization: "Default organization OTP for Signup",
        crop: "Crop",
        maxProductionError: "Maximum Production must be entered",
        selectCountryError: "Please select country first",
        selectCropError: "Please select crop first",
        unitError: "Please set max production and unit",
        per_hour: "Per Hour",
        per_day: "Per Day",
        per_minute: "Per Minute",
        per_week: "Per Week",
        per_month: "Per Month",
        per_year: "Per Year",
        per_second: "Per Second",
        per_session: "Per Session",
        per_login: "Per Login",
        mins: "Minutes",
        hours: "Hours",
        days: "Days",
        weeks: "Weeks",
        months: "Months",
        years: "Years",
        seconds: "Seconds",
        customized: "Customized",
      },

      adminRoles: {
        adminRoles: "Admin Roles",
        roleName: "Role Name",
        description: "Description",
        viewPermissions: "View Permissions",
        createAdminRole: "CREATE ADMIN ROLE",
        enterDesHere: "Enter your description here",
        deleteRole: "Delete Roles",
        deleteMsg: "Are you sure you want to delete role?",
        roleReq: "Role name is required",
        roleLimit: "Role name must be less than 15 characters",
        desReq: "Description is required",
        desLimit: "Description must be 40 characters or less",
        roleSuccess: "Role created successfully",
        editAdminRole: "Edit Admin Role",
        roleUpdated: "Role Updated",
        noRole: "No Admin Roles Found",
        noRoleMsg:
          "Please create admin role using the button 'Create Admin Role' above",
        roleType: "Role Type",
      },

      roleRequest: {
        roleRequest: "Role Request",
        userRole: "User Role",
        approve: "Approve",
        reject: "Reject",
        username: "userName",
        email: "Email",
        phone: "Phone",
        roleAssigned: "Role Assigned",
        roleRequested: "Role Requested",
        requestedDate: "Requested Date",
        updateRoleRequest: "Update Role Request",
        message: "Message",
        update: "Update",
      },

      userslist: {
        existingUser: "Select from existing app user",
        addRole: "Add Role",
        newUser: "Create new admin user",
        convertUser: "Convert to admin user",
        createNewUser: "Create a New User",
        chooseCreateType: "Please choose one of the following options:",
        addNewUser: "Add New User",
        editUser: "Edit User",
        addNewAdmin: "Add Admin User",
        userLoading: "Loading Users... Please wait",
        noUser: "NO USER AVAILABLE",
        extendVal: "EXTEND VALIDITY",
        extendReason: "Reason for Extension",
        extendReasonMsg: "Specify the reason for membership extension",
        exportAsCSV: "EXPORT AS CSV",
        membershipType: "Membership Type",
        membershipValidity: "Membership Validity",
        regionState: "Region/State",
        cityTown: "City/Town",
        clearAll: "CLEAR ALL",
        search: "SEARCH",
        familyTribe: "Enter your family tribe",
        enterWebsite: "Enter website",
        registrationDate: "Registration Date",
        single: "Single",
        multiple: "Multiple",
        user: "User",
        users: "Users",
        role: "User Role(s)",
        department: "Department",
        registerUser: "Register User(s)",
        singleUser: "Single User",
        multipleUser: "Multiple User",
        selectMembership: "Select Membership",
        selectActivationKey: "Select Activation Key",
        generateKey: "Generate Key",
        updateKey: "Update Key",
        deactivateUser: "Deactivate User",
        farmerRolePermission: "Farmer Role Permission",
        bulkUploadUser: "Bulk Upload Users",
        allUsers: "All Users",
        technician: "Technician",
        farmer: "Farmer",
        factoryBuyingStation: "Factory / Buying Station User",
      },

      addEdituser: {
        facilityPicture: "Facility Picture",
        firstNameRequired: "First Name is required",
        roleNameOnlyAlpha: "Role Name can can contain only alphabets",
        roleNameLimit: "Role Name must be less than 100 characters",
        firstNameOllyAlpha: "First Name can contain only alphabets",
        firstNameLimit: "First Name must be less than 50 characters",
        departmentRequired: "Department Field is required",
        lastNameRequired: "Last Name is required",
        lastNameOllyAlpha: "Last Name can contain only alphabets",
        lastNameLimit: "Last Name must be less than 50 characters",
        emailReuired: "Email is required",
        emailInvalid: "Invalid email format.",
        mobileRequired: "Mobile number is required",
        mobileLimit: "Mobile number must be less than 15 digits",
        invalidMobile: "Invalid mobile number format.",
        emailExistAlready: "User already exist with this email.",
        mobileExistAlready: "User already exist with this mobile number.",
        pswRequired: "Password is required",
        deptRequired: "Department is required",
        roleRequired: "Role is required",
        countryRequired: "Country Code is required",
        userUpdated: "User Updated",
        userNotUpdated: "User Not Updated",
        activateAct: "Activate Account",
        deactivateAct: "Deactivate Account",
        areYouSureYouWantToDeactivateThisFarmer: "Are you sure you want to deactivate this farmer?",
        userActivated: "User Activated",
        userDeactivated: "User Deactivated",
        deactivateUser: "Deactivate User",
        deactivateMsg: "Are you sure you want to change user status.",
        userAdded: "User Added",
        roleAdded: "Role Added",
        failedToAdd: "Failed to add",
        userNotAdded: "User Not Added",
        editAppUser: "Edit App User",
        validityUpTo: "Membership Validity Up To",
        roleEdited: "Role Edited",
        addDepartment: "Add Department",
        editDepartment: "Edit Department",
        department: "Department",
        noDepartment: "No Department",
        departmentNameRequired: "Department name is required",
        departmentAdded: "Department Added",
        departmentEdited: "Department Edited",
        eoriNumberRequired: "EORI number required",
        eoriIsNumber: "EORI must be number",
        addNewSupplier: "Add New Supplier",
        addNewProducer: "Add New Producer",
        addNewOperator: "Add New Operator",
        eoriNumber: "EORI Number",
      },

      membership: {
        remainingDays: "Number of Extended Days",
        type: "Membership Type",
        validity: "Membership Validity",
        validityLength: {
          custom: "Custom",
          expired: "Expired",
          oneTo8Months: "1-8 months",
          lessThan1Month: "Less than 1 month",
          moreThan1Month: "More than 1 year",
          sixTo12Months: "6-12 months",
        },
      },
      membershipplanSection: {
        noAdminMembershipsFound: "No admin memberships found",
        pleaseAddMembership:
          "Please add a membership using the 'Add Membership' button above",
        defaultMembership: "Default Membership",
        areYouSureDefault:
          "Are you sure you want to make this membership type default?",
        changeDefaultPlan: "Change Default Plan",
        defaultPlan: " DEFAULT PLAN",
        planDuration: "Plan Duration",
        planFee: "Plan Fee",
        satelliteReport: "SATELLITE REPORT",
        advanceReport: "ADVANCE REPORT",
        addMembership: "ADD MEMBERSHIP",
        addMembershipPlan: "Add Membership Plan",
        editMembershipPlan: "Edit Membership Plan",
        accessSetelite: "Access to Satellite Reports (Set of 5 reports)",
        accessAdvanceReport: "Access to Advanced Reports",
        memPlanReq: "Membership Plan is required",
        memPlanReqLimit: "Membership plan must be less than 20 characters",
        SatelliteReq: "Satellite Report is required",
        advancedReportReq: "Advanced Report is required",
        durationReq: "Membership Duration is required",
        feeReq: "Membership Fee is required",
        cantLesThenZero: "Can't be less than 0",
        roleReq: "User role is required",
        selectPlan: "Select Plan",
        planType: "Plan Type",
        enterprise: "Enterprise",
        membershipType: "Membership Type",
        selectMembershipType: "Select Membership Type",
        membershipTypeReq: "Membership type is required",
        membershipTypeDefault: "Default",
        membershipTypeFarmer: "Farmer",
        membershipTypeTechnician: "Technician",
        membershipTypeFactoryBuying: "Factory / Buying Station",
        noOfUsersAllowed: "No. of users allowed",
        noOfFarms: "No. of Farms",
        farmsAndQuantity: "Farms & Quantity",
        perUser: "Per User",
        perFarm: "Per Farm",
        accessToDeforestationReport: "Access to Deforestation Reports (Per User)",
        satelliteReportPackage: "Satellite Report Package",
        basicFarmLevelReports: "Basic Farm Level Reports",
        advancedFarmLevelReports: "Advanced Farm Level Reports",
        largeAreaReports: "Large Area Reports",
      },
     
      statusItems: {
        closed: "Closed",
        open: "Open",
        moreInfoReq: "More Information Required",
      },
      orderByItems: {
        all: "All",
        dateAscending: "Date Ascending",
        dateDescending: "Date Descending",
        dueDate: "Due Date",
        high: "High",
        low: "Low",
        medium: "Medium",
      },

      record: {
        id: "ID",
        module: "Module",
        harvestingDate: "Harvesting Date",
        noOfTrees: "No Of Trees",
        reason: "Reason",
        userId: "User ID",
        appVersion: "App Version",
        createdAt: "Created At",
      },

      ownershipTypes: {
        EXW: "EXW (Ex Works)",
        FCA: "FCA (Free Carrier)",
        CPT: "CPT (Carriage Paid To)",
        CIP: "CIP (Carriage and Insurance Paid To)",
        DAP: "DAP (Delivered at Place)",
        DPU: "DPU (Delivered at Place Unloaded)",
        DDP: "DDP (Delivered Duty Paid)",
        FAS: "FAS (Free Alongside Ship)",
        FOB: "FOB (Free on Board)",
        CFR: "CFR (Cost and Freight)",
        CIF: "CIF (Cost, Insurance and Freight)"
      },

      Enterprises:{
        Enterprise: "Enterprise",
        Resgister_New_Enterprise: "Register New Enterprise",
        Registration_Date: "Registration Date",
        Activation_Keys: "Activation Keys",
        "EnterpriseDetailsForm": {
          "Submit" : "Submit",
          "Register_New_Enterprise_Client_Organization" : "Register New Enterprise/Client/Organization",
          "Enterprise_Client_Organization_Name": "Enterprise/Client/Organization Name",
          "Enterprise_Client_Organization_Logo": "Enterprise/Client/Organization Logo",
          "Browse": "Browse",
          "Supported_File_Format": "supported file format JPG, PNG, GIF, SVG",
          "Enterprise_Client_Organization_Phone_Number": "Enterprise/Client/Organization Phone Number",
          "Language_s": "Language(s)",
          "Select_Language": "Select Language",
          "Crop_Variety": "Crop Variety",
          "Select_Crop_Variety": "Select Crop Variety",
          "User_Role_s": "User Role(s)",
          "Select_User_Role": "Select User Role",
          "Country": "Country",
          "Select_Country": "Select Country",
          "Province_State": "Province / State",
          "Region_District": "Region / District",
          "Village_Town_City": "Village / Town / City",
          "Address": "Address",
          "Status": "Status",
          "Select_Status": "Select Status"
        },
        "EnterpriseUsers": {
          "Enterprise_Users": "Enterprise Users",
          "Users": "Users",
          "Register_Users": "REGISTER USER(S)",
          "Search": "Search",
          "All_Countries": "All Countries",
          "All_Regions": "All Regions",
          "All_Forms": "All Forms",
          "Page_Of": "Page {page} of {totalPages}",
          "Activation_Key": "Activation Key",
          "User_Name_ID": "User Name & ID",
          "Full_Name": "Full Name",
          "Email": "Email",
          "User_Role": "User Role",
          "User_Registration_Date": "User Registration Date",
          "Status": "Status",
          "Active": "Active",
          "Inactive": "Inactive",
          "All": "All",
          "Active_Users": "Active Users",
          "Offline_Users": "Offline Users",
          "Deactivated_Users": "Deactivated Users",
          "App_Users": "App Users",
          "Admin_Users": "Admin Users"
        },
        "AdminUsersForm": {
          "Admin_User": "Admin User",
          "Name": "Name",
          "Email": "Email",
          "Add_More": "Add More",
          "Remove": "Remove"
        },
        "AdminEnvironmentDialog": {
        "Create_Admin_Environment": "Create Admin Environment",
        "Creating_Admin_Environment": "Creating Admin Environment",
        "Please_Wait": "Please Wait",
        "Cancel": "CANCEL"
        },
        "ProfileInfo": {
        "Crop_Variety": "Crop Variety",
        "Membership_Plan": "Membership Plan",
        "Advanced": "Advanced"
       },
        "ModuleAccess": {
        "Access_to_Modules_on_Admin_Panel": "Access to Modules on Admin Panel",
        "Dashboard": "Dashboard",
        "Coffee_Overview": "Coffee Overview",
        "Farm_Management": "Farm Management",
        "Survey_Builder": "Survey Builder",
        "Deforestation": "Deforestation",
        "User_Management": "User Management",
        "FAQ": "Frequently Asked Questions (FAQ)",
        "Tickets": "Tickets",
        "Activity_Log": "Activity Log",
        "Settings": "Settings",
        "Member_Data": "Member Data",
        "Admin_Roles": "Admin Roles"
       },
        "BillingSummary": {
        "Billing_Summary": "Billing Summary",
        "Update_Payment_Info": "Update your payment information or switch plans according to your needs.",
        "Base_Plan_Package": "Base Plan Package",
        "Total_Paid": "Total Paid",
        "To_Be_Paid": "To be Paid",
        "Manage_Plan": "MANAGE PLAN",
        "Extra_Usage": "Extra Usage",
        "Change_Billing_Period": "CHANGE BILLING PERIOD",
        "Total_Amount_Due": "Total Amount Due",
        "Billing_History": "Billing History",
        "Search": "Search",
        "Transaction_ID": "Transaction ID",
        "Admin_User": "Admin User",
        "Amount": "Amount",
        "Mode_of_Payment": "Mode of Payment",
        "Transaction_Date": "Transaction Date",
        "Receipt": "Receipt",
        "Status": "Status",
        "Paid": "Paid",
        "Unpaid": "Unpaid",
        "View": "View"
       },
        "ListingEnterprises": {
        "Search": "Search",
        "Export_As_CSV": "Export as CSV",
        "Records_Selected": "records selected",
        "Create_Admin_Environment": "CREATE ADMIN ENVIRONMENT",
        "Deactivate": "DEACTIVATE",
        "Enterprise": "Enterprise",
        "Registration_Date": "Registration Date",
        "Activation_Keys": "Activation Keys",
        "Status": "Status",
        "Actions": "Actions",
        "View": "View",
        "Edit": "Edit",
        "Request_Extra_Reports": "Request Extra Reports",
        "Create_Admin_Environment_Action": "Create Admin Environment",
        "Deactivate_Action": "Deactivate"
       },
      },
      
    
}